// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".viewer .office-viewer{height:100vh;height:100dvh;top:-50px}", "",{"version":3,"sources":["webpack://src/view/Office.vue"],"names":[],"mappings":"AACA,uBACC,YAAA,CAEA,aAAA,CACA,SAAA","sourcesContent":["\n.viewer .office-viewer {\n\theight: 100vh;\n\t/* stylelint-disable-next-line */\n\theight: 100dvh;\n\ttop: -50px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
